<template>
  <div class="map-container">
    <div class="boye-every">
      <div class="chinese">伯艺 @ 随处可见</div>
      <el-divider direction="vertical" />
      <div class="english">BOYI CAN BE SEEN EVERYWHERE</div>
    </div>
    <div class="boye-service">
      <div class="english">SERVICE</div>
      <div class="chinese">准备好为您服务</div>
    </div>

    <div class="boye-count">
      <div class="title">400多家</div>
      <div class="description">下线体验店</div>
    </div>
    <div class="map-view">
      <el-image src="static/images/china_map.jpg" />
    </div>

    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-hlj" src="static/images/point.gif" @click="onMapPointClick('黑龙江')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-jl" src="static/images/point.gif" @click="onMapPointClick('吉林')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-ln" src="static/images/point.gif" @click="onMapPointClick('辽宁')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-bj" src="static/images/point.gif" @click="onMapPointClick('北京')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-tj" src="static/images/point.gif" @click="onMapPointClick('tj')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-hb" src="static/images/point.gif" @click="onMapPointClick('hb')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-sx" src="static/images/point.gif" @click="onMapPointClick('山西')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-sd" src="static/images/point.gif" @click="onMapPointClick('山东')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-js" src="static/images/point.gif" @click="onMapPointClick('江西')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-ah" src="static/images/point.gif" @click="onMapPointClick('安徽')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-hn" src="static/images/point.gif" @click="onMapPointClick('湖南')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-sxx" src="static/images/point.gif" @click="onMapPointClick('陕西')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-cq" src="static/images/point.gif" @click="onMapPointClick('重庆')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-hub" src="static/images/point.gif" @click="onMapPointClick('湖北')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-hun" src="static/images/point.gif" @click="onMapPointClick('湖南')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-gz" src="static/images/point.gif" @click="onMapPointClick('广州')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-jx" src="static/images/point.gif" @click="onMapPointClick('江西')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-fj" src="static/images/point.gif" @click="onMapPointClick('福建')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-nx" src="static/images/point.gif" @click="onMapPointClick('宁夏')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-nm" src="static/images/point.gif" @click="onMapPointClick('内蒙')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-gs" src="static/images/point.gif" @click="onMapPointClick('甘肃')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-qh" src="static/images/point.gif" @click="onMapPointClick('青海')" />
    </el-tooltip>
    <el-tooltip effect="dark" content="点击查看详情">
      <el-image class="point-xj" src="static/images/point.gif" @click="onMapPointClick('新疆')" />
    </el-tooltip>

    <el-drawer :visible.sync="showPointer" :show-close="false">
      <div class="drawer" v-loading="loading">
        <div class="empty" v-if="mapData.length === 0">暂无数据 敬请期待</div>
        <div v-else>
          <el-image src="static/images/boye_home.jpeg" />
          <el-divider>{{provinceName}}地区 伯艺木门</el-divider>
          <div v-for="item in mapData" :key="item.id">
            <div class="item">{{item.name}}</div>
            <div class="item">{{item.address + item.detailedAddress}}</div>
            <div class="item">{{item.phone}}</div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { listSearchMixin } from '@/config/mixin'
import API from '@/api/index'

export default {
  mixins: [listSearchMixin],
  data() {
    return {
      showPointer: false,
      mapData: {},
      loading: false,
      provinceName: ''
    }
  },

  methods: {
    onMapPointClick(val) {
      this.provinceName = val
      this.loading = true
      let params = {
        url: API.getSystemStoreInfo,
        method: 'GET',
        params: {
          province: val
        }
      }
      console.log('params', params)
      try {
        this.sendReq(params, (res) => {
          this.showPointer = true
          this.loading = false
          console.log('result = ', res)
          if (res.status === 200) {
            this.mapData = res.data
          } else {
            this.mapData = []
          }
        })
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  height: 800px;
  background-color: white;
  padding: 98px;
  position: relative;
  .map-view {
    left: 320px;
    top: 100px;
    position: absolute;
    .el-image {
      width: 800px;
      height: 638px;
    }
  }
  .boye-every {
    position: relative;
    top: -50px;
    .el-divider {
      position: absolute;
      left: 130px;
      top: 14px;
      height: 290px;
    }
    .chinese {
      width: 15px;
      line-height: 32px;
      font-size: 28px;
      position: absolute;
      left: 150px;
      top: 10px;
    }
    .english {
      position: absolute;
      left: -20px;
      top: 148px;
      font-size: 18px;
      line-height: 22px;
      color: grey;
      transform: rotate(90deg);
      -ms-transform: rotate(90deg); /* IE 9 */
      -moz-transform: rotate(90deg); /* Firefox */
      -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
      -o-transform: rotate(90deg); /* Opera */
    }
  }

  .boye-service {
    position: absolute;
    left: 220px;
    top: 440px;
    z-index: 999;
    .english {
      line-height: 32px;
      font-size: 28px;
    }
  }

  .boye-count {
    border: grey solid 1px;
    position: absolute;
    left: 220px;
    top: 520px;
    z-index: 9999;
    padding: 16px;
    .title {
      line-height: 34px;
      font-size: 30px;
      font-weight: bold;
    }
    .description {
      line-height: 30px;
      font-size: 26px;
    }
  }

  .point-hlj {
    position: absolute;
    left: 980px;
    top: 192px;
    z-index: 2;
    cursor: pointer;
  }
  .point-jl {
    position: absolute;
    left: 980px;
    top: 252px;
    z-index: 2;
    cursor: pointer;
  }
  .point-ln {
    position: absolute;
    left: 990px;
    top: 295px;
    z-index: 2;
    cursor: pointer;
  }
  .point-bj {
    position: absolute;
    left: 900px;
    top: 302px;
    z-index: 2;
    cursor: pointer;
  }
  .point-tj {
    position: absolute;
    left: 925px;
    top: 340px;
    z-index: 2;
    cursor: pointer;
  }
  .point-hb {
    position: absolute;
    left: 900px;
    top: 358px;
    z-index: 2;
    cursor: pointer;
  }
  .point-sx {
    position: absolute;
    left: 858px;
    top: 382px;
    z-index: 2;
    cursor: pointer;
  }
  .point-sd {
    position: absolute;
    left: 890px;
    top: 394px;
    z-index: 2;
    cursor: pointer;
  }
  .point-js {
    position: absolute;
    left: 935px;
    top: 450px;
    z-index: 2;
    cursor: pointer;
  }
  .point-ah {
    position: absolute;
    left: 915px;
    top: 490px;
    z-index: 2;
    cursor: pointer;
  }
  .point-hn {
    position: absolute;
    left: 876px;
    top: 440px;
    z-index: 2;
    cursor: pointer;
  }
  .point-sxx {
    position: absolute;
    left: 810px;
    top: 430px;
    z-index: 2;
    cursor: pointer;
  }

  .point-cq {
    position: absolute;
    left: 775px;
    top: 520px;
    z-index: 2;
    cursor: pointer;
  }

  .point-hub {
    position: absolute;
    left: 870px;
    top: 493px;
    z-index: 2;
    cursor: pointer;
  }
  .point-hun {
    position: absolute;
    left: 862px;
    top: 555px;
    z-index: 2;
    cursor: pointer;
  }
  .point-gz {
    position: absolute;
    left: 790px;
    top: 570px;
    z-index: 2;
    cursor: pointer;
  }
  .point-jx {
    position: absolute;
    left: 915px;
    top: 545px;
    z-index: 2;
    cursor: pointer;
  }

  .point-fj {
    position: absolute;
    left: 960px;
    top: 570px;
    z-index: 2;
    cursor: pointer;
  }

  .point-nx {
    position: absolute;
    left: 770px;
    top: 382px;
    z-index: 2;
    cursor: pointer;
  }

  .point-nm {
    position: absolute;
    left: 795px;
    top: 329px;
    z-index: 2;
    cursor: pointer;
  }

  .point-gs {
    position: absolute;
    left: 650px;
    top: 333px;
    z-index: 2;
    cursor: pointer;
  }

  .point-qh {
    position: absolute;
    left: 640px;
    top: 402px;
    z-index: 2;
    cursor: pointer;
  }

  .point-xj {
    position: absolute;
    left: 492px;
    top: 310px;
    z-index: 2;
    cursor: pointer;
  }

  .drawer {
    padding-left: 32px;
    padding-right: 32px;
    font-size: 18px;
    line-height: 22px;
    .empty {
      width: 100%;
      text-align: center;
      font-size: 18px;
      line-height: 22px;
      color: black;
    }
    .el-divider__text,
    .el-link {
      font-size: 20px;
      line-height: 24px;
      color: black;
    }
    .item {
      margin-top: 8px;
    }
  }
  //   <el-image class="point-qh" src="static/images/point.gif" />
  //   <el-image class="point-xj" src="static/images/point.gif" />
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/chinaMap.vue